const initialState = {
  errors:[],
};

export function fetchDealerConfigurationCheck(state = initialState, action) {
  switch (action.type) {
    case 'FETCH.DEALER_CONFIGURATION_CHECK.SUCCESS':

      return {
        ...state,
        configurationHints: action.config.body || [],
      };
    default:
      return state
  }
}
